<template>
  <div>
    <div class="container-fluid m-0 p-0" >
      <bildSchwenkMitText />
      <balkenMitBild />      
      <bildMitKachel />
    </div>
    <stickybarTelMail />
  </div>
  <stickyPfeil/>
</template>

<script>
//import carouselHeader from "../components/carouselHeader.vue";
import bildMitKachel from "../components/bildMitKacheln.vue";
import balkenMitBild from "../components/balkenMitBild.vue";
import stickybarTelMail from "../components/stickybarTelMail.vue";
import bildSchwenkMitText from "../components/bildSchwenkMitText.vue";
import stickyPfeil from "../components/stickyPfeil.vue";
export default {
  name: "MainPage",

  data() {
    return {
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      newSite: null,
    };
  },
  components: {
    bildMitKachel,
    balkenMitBild,
    stickybarTelMail,
    bildSchwenkMitText,
    stickyPfeil,
    //  carouselHeader,
  },
  methods: {},
  computed: {},
  mounted() {
    window.onresize = () => {
      this.windowHeight = window.innerHeight;
    };
  },
};
</script>

<style scoped></style>
